import * as Sentry from '@sentry/react';
import { registerLicense } from '@syncfusion/ej2-base';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n'; // OXX-883: initialise i18next before React renders

Sentry.init({
  dsn: document.querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')
    ?.content,
});

const syncfusionLicenseKey =
  document.querySelector<HTMLMetaElement>('meta[name="syncfusion-license-key"]')
    ?.content ?? '';
registerLicense(syncfusionLicenseKey);

// Wait for DOM content to be loaded
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');

  if (!container) {
    throw new Error(
      'Root element not found! Add a div with id="root" to your HTML'
    );
  }

  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
